import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

const checkRegistration = async () => {
  try {
    return await customFetch(API_ENDPOINTS.CHECK_REGISTRATION, { method: 'GET' });
  } catch (error) {
    console.error('登録確認エラー:', error);
    throw error;
  }
};

const updateWelcomeVisit = async () => {
  try {
    return await customFetch(`${API_ENDPOINTS.CHECK_REGISTRATION}/welcome-visit`, { method: 'POST' });
  } catch (error) {
    console.error('ウェルカム画面訪問フラグ更新エラー:', error);
    throw error;
  }
};

export const registrationCheckService = {
  checkRegistration,
  updateWelcomeVisit
};
